import { useEffect } from 'react';

import { useRoomOptionsData } from '@/v2/components/pages/PackageView/contexts/RoomOptionsContext';
import { otherOptionVisibleDataLayerEvent } from '@/v2/components/pages/PackageView/utils/dataLayer/dataLayer';

const useIsOtherOptionsVisibleDataLayerEvent = () => {
  const { upgradeOffer, isPreSearch, isLoading } = useRoomOptionsData() || {};
  const isOfferAvailable = !!upgradeOffer;

  useEffect(() => {
    if (!isPreSearch && !isLoading) {
      otherOptionVisibleDataLayerEvent({ isVisible: isOfferAvailable });
    }
  }, [isLoading, isPreSearch, isOfferAvailable]);
};

export default useIsOtherOptionsVisibleDataLayerEvent;
